import { Box, Card, Typography, styled, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

const FooterWrapper = styled(Card)(
  ({ theme }) => `
        border-radius: 0;
        margin-top: ${theme.spacing(2)};
        border-top:2px solid #f2f5f9;  
      }    
`
);
const TypographyFooter = styled(Typography)(
  () => `
        text-align:center;
        font-weight:700;
`
);
const TypographyFooter2 = styled(Typography)(
  () => `
        text-align:center;
        font-weight:300;

        .privacy__policy {
          text-decoration: none;
          color:rgba(34, 51, 84, 0.7);

          &:hover {
            text-decoration: underline;
          }
        }
`
);

const REACT_APP_WECOMPAIR_TERMS =
  'https://www.wecompair.eu/terms-and-conditions';

function Footer({component}) {
  const { t } = useTranslation();

  return (
    <FooterWrapper>
      <Box
        p={3}
        display={{ xs: 'block', md: 'flex' }}
        alignItems="center"
        textAlign={{ xs: 'center', md: 'left' }}
        justifyContent="center"
      >
        <Box>
          <TypographyFooter variant="subtitle1">
            ©2022 {t('by COMPAIR Project')}
          </TypographyFooter>
          <TypographyFooter2 variant="subtitle1" maxWidth={1000}>
            {t(
              `This project has received funding from the European Union's Horizon 2020 research and innovation programme under grant agreement No 101036563. This website represents the views of the COMPAIR project only.`
            )}
          </TypographyFooter2>
          <TypographyFooter2
            variant="subtitle1"
            sx={{ display: 'flex', justifyContent: 'center', gap: '20px' }}
          >
            <Link
              href={REACT_APP_WECOMPAIR_TERMS}
              color="text.secondary"
              target="_blank"
            >
              <b>{t('Terms & Conditions')}</b>
            </Link>
            {component === 'CO2' && (
              <RouterLink
                to="CO2-privacy-policy"
                color="text.secondary"
                target="_blank"
                className="privacy__policy"
              >
                <b>{t('Privacy Policy')}</b>
              </RouterLink>
            )}
          </TypographyFooter2>
        </Box>
      </Box>
    </FooterWrapper>
  );
}

export default Footer;
